module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/tv-border-a2356d22fb339d5c56c5e2fec0a97c9f.png";